import type { EventFilter } from "@/Modules/Chat/WebSocketManager";

import { type ExtraParamsUnknownChatRoomItem } from "./UnknownChatRoomItem";
import type { TextChatRoomItem } from "../Models/Domain/Chat";
import {
  ChatRoomItemTypeMessageWebSocket,
  MessageTypeWebSocket,
  type ReceivedEventMessageWebSocket,
} from "@/Modules/Chat/Models/WebSocket";

import { useChatStore, type ChatStore } from "../Store";

import { hasValue, isObject } from "@/Utils/Objects";
import { isValidString } from "@/Utils/String";

export interface ExtraParamsReceivedChatRoomItem {
  chatStore: ChatStore;
}

export const isConfirmChatRoomItem = (message: unknown): message is ReceivedEventMessageWebSocket => {
  return (
    isObject(message) &&
    hasValue(message.type) &&
    isValidString(message.rd_eid) &&
    message.etype === ChatRoomItemTypeMessageWebSocket.CONFIRMATION &&
    message.type === MessageTypeWebSocket.CHAT_ROOM_ITEM
  );
};

export const confirmSendMessageHandler = (
  message: ReceivedEventMessageWebSocket,
  { chatStore = useChatStore() }: ExtraParamsReceivedChatRoomItem
): Promise<undefined> => {
  const { chat, rd_eid } = message;

  if (chatStore.rooms[chat]) {
    const index = chatStore.rooms[chat].events.findIndex((e) => e.id === rd_eid);

    if (index !== -1) {
      (chatStore.rooms[chat].events[index] as TextChatRoomItem).isReceived = true;
    }
  }

  return Promise.resolve(undefined);
};

export default {
  isType: isConfirmChatRoomItem,
  handler: confirmSendMessageHandler,
} as EventFilter<ExtraParamsUnknownChatRoomItem>;
